export function pagetop() {
  const pageTop = document.querySelector('.js-pagetop');

  if (pageTop) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        pageTop.classList.add('is-show');
      } else {
        pageTop.classList.remove('is-show');
      }
    });

    pageTop.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}